export const HelpCenterArticles = {
  helpCenter: 'https://apisupport.gelato.com/hc/en-us',
  fulfilment: 'https://apisupport.gelato.com/hc/en-us/articles/360019090059',
};
